module.exports = __webpack_public_path__ + "static/media/t-2-q-9-4.12ba48f8.png";